import JsBarcode from 'jsbarcode';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

const BarcodeGenerator = props => {
	const {
		className = '',
		dataqa = 'barcode-generator',
		displayValue = false,
		format = 'CODE128B',
		barcode = '',
		width = 1,
		height = 50,
		margin = 0,
		...rest
	} = props;

	const svgEl = useRef(null);

	// the effect will only run once when the component mounts
	useEffect(() => {
		if (svgEl.current && barcode !== '') {
			JsBarcode(svgEl.current, barcode, {
				format,
				displayValue,
				height,
				width,
				margin,
				...rest,
			});
		}
	}, []);

	return (
		<div className={`common-ui-barcode-generator ${className}`}>
			<svg ref={svgEl} data-qa={dataqa} {...{ dataqa }} />
		</div>
	);
};

BarcodeGenerator.propType = {
	barcode: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired,

	// select which barcode type to use. (default: CODE128)
	format: PropTypes.string,

	// width of a single bar. (default: 2)
	width: PropTypes.number,

	// height of the barcode. (default: 50)
	height: PropTypes.number,

	// see more options here:
	// https://github.com/lindell/JsBarcode/wiki/Options
};

export default BarcodeGenerator;
